// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getTopSellingProductApi } from "../../Service/Api/TopSellingProductApi"
import { getTopSellingList,getErrors } from "../Reducer/TopSellingProductReducer"
 


// Watchers
function* topSellingProudctListSaga() {
	yield takeEvery("topSelling_list/getTopSelling", getAllTopSelling)
}

// Sagas
function* getAllTopSelling(action) {
	 
	try {
		const getTopSelling = yield call(getTopSellingProductApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getTopSelling.request.status === 200) {
			yield put(getTopSellingList(getTopSelling))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(topSellingProudctListSaga)])
}
